import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { CtaBand } from "../components/CtaBand";
import { BLOG_POSTS } from "../data/blog";
import { IMAGES } from "../data/site";

export default function BlogIndex() {
    return (
        <div data-testid="blog-index-page">
            <Seo
                title="Security Intel & Guides Scotland | Xtreme Protection Blog"
                description="Practical security guides for Scottish businesses: security guard costs, SIA licence checks, construction site security, retail crime prevention, event security and key holding."
            />
            <PageHero
                image={IMAGES.cctv}
                imageAlt="Security intelligence and guides for Scottish businesses"
                kicker="Scotland Security Operations // Intel"
                title="Security Intel &"
                titleAccent="Practical Guides"
                sub="Straight-talking guides for Scottish businesses: costs, compliance, checklists and the tactics that actually reduce risk."
                testidPrefix="blog-index"
            />
            <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    {BLOG_POSTS.map((p, i) => (
                        <Reveal key={p.slug} delay={(i % 3) * 0.06}>
                            <Link
                                to={`/blog/${p.slug}`}
                                data-testid={`blog-card-${p.slug}`}
                                className="group flex flex-col bg-[#0F1117] hover:bg-[#161922] transition-colors duration-300 h-full"
                            >
                                <div className="relative h-44 overflow-hidden">
                                    <img
                                        src={p.image}
                                        alt={p.title}
                                        className="w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700"
                                        loading="lazy"
                                    />
                                    <span className="absolute top-4 left-4 font-mono-xp text-[10px] uppercase tracking-[0.2em] bg-[#E53E3E] text-white px-2.5 py-1">
                                        {p.category}
                                    </span>
                                </div>
                                <div className="p-6 flex flex-col flex-1">
                                    <h2 className="font-display uppercase font-bold text-xl tracking-wide text-white group-hover:text-[#E53E3E] transition-colors leading-tight">
                                        {p.title}
                                    </h2>
                                    <p className="text-gray-500 text-sm leading-relaxed mt-3 flex-1">{p.excerpt}</p>
                                    <div className="flex items-center justify-between mt-5 pt-4 border-t border-white/10">
                                        <span className="flex items-center gap-3 font-mono-xp text-[10px] uppercase tracking-widest text-gray-600">
                                            <span className="flex items-center gap-1"><Calendar size={11} /> {new Date(p.date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</span>
                                            <span className="flex items-center gap-1"><Clock size={11} /> {p.readTime}</span>
                                        </span>
                                        <ArrowRight size={14} className="text-gray-600 group-hover:text-[#E53E3E] group-hover:translate-x-1 transition-all duration-300" />
                                    </div>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </section>
            <CtaBand />
        </div>
    );
}
